module.exports = __webpack_public_path__ + "img/becomb.499a0668.jpg";